import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { Link } from "react-router-dom";
import Circles from '../../../assets/images/circle.png';
function NaturalFarmingAnalytic() {
    return (
<>
<main id="main" className="main AdminAccess">
          <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
        <nav>
       <h1>Natural Farming Analytic</h1>
         <ol className="breadcrumb">
           <li className="breadcrumb-item">Admin</li>
           <li className="breadcrumb-item active">Natural Farming Analytic</li>
         </ol>
       </nav>
       <Link className="btn btn-success" to="/AdminAccess">Back</Link>
     </div>
 <div className="container-fluid ">
<div className='card'>
    <div className='card-body onbordedSchemess schemesreport '>
        <h3>Natural Farming Dashboard</h3>
        <div className='row d-flex justify-content-center'>
            <div className='col-md-2'>
                <label>Financial Year</label>
                <select className='form-select'>
                    <option>Select Financial Year</option>
                    <option>2022 - 2023</option>
                    <option>2023 - 2024</option>
                </select>
            </div>
            <div className='col-md-2'>
                <label>Crops Name</label>
                <select className='form-select'>
                    <option>Select Crops Name</option>
                    <option>Caster</option>
                    <option>Finger</option>
                    <option>Green Gram</option>
                </select>
            </div>
            <div className='col-md-2'>
                <label>State</label>
                <select className='form-select'>
                    <option>Select State</option>
                    <option>Andhra Pradesh</option>
                    <option>Uttar Pradesh</option>
                    <option>Himachal Pradesh</option>
                </select>
            </div>
            <div className='col-md-2'>
                <label>District</label>
                <select className='form-select'>
                    <option>Select District</option>
                    <option>Agra</option>
                    <option>Kanpur</option>
                    <option>Lucknow</option>
                </select>
            </div>
            <div className='col-md-2'>
                <label>Block</label>
                <select className='form-select'>
                    <option>Select Block</option>
                    <option>Achnera</option>
                    <option>Bichpuri</option>
                </select>
            </div>
            <div className='col-md-2'>
                <label>Village</label>
                <select className='form-select'>
                    <option>Select Village</option>
                    <option>Sahari</option>
                    <option>Anguthi</option>
                </select>
            </div>           
        </div>
      
    </div>
</div>
<div className='row naturalfarmingCards'>
        <div className="col-xxl-2 col-md-2">
    <div className="card info-card  sales-card bg-gradient-success card-img-holder">
<div className="card-body">
<img src={Circles} className="card-img-absolute" alt="circle-image"/> 
          <h5 className="card-title">Active Survey <span>| This Year</span></h5>

          <div className="d-flex align-items-center">
            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
            <i><FontAwesomeIcon icon={faUser} /> </i>
            </div>
            <div className="ps-3">
              <h6></h6>
              {/* <span className="text-success small pt-1 fw-bold">8%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}

            </div>
          </div>
        </div>

      </div>
    </div>
    <div className="col-xxl-2 col-md-2">
    <div className="card info-card  sales-card bg-gradient-primary card-img-holder">
<div className="card-body">
<img src={Circles} className="card-img-absolute" alt="circle-image"/> 
          <h5 className="card-title">Active Survey <span>| This Year</span></h5>

          <div className="d-flex align-items-center">
            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
            <i><FontAwesomeIcon icon={faUser} /> </i>
            </div>
            <div className="ps-3">
              <h6></h6>
              {/* <span className="text-success small pt-1 fw-bold">8%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}

            </div>
          </div>
        </div>

      </div>
    </div>
    <div className="col-xxl-2 col-md-2">
    <div className="card info-card  sales-card bg-gradient-danger card-img-holder">
<div className="card-body">
<img src={Circles} className="card-img-absolute" alt="circle-image"/> 
          <h5 className="card-title">Active Survey <span>| This Year</span></h5>

          <div className="d-flex align-items-center">
            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
            <i><FontAwesomeIcon icon={faUser} /> </i>
            </div>
            <div className="ps-3">
              <h6></h6>
              {/* <span className="text-success small pt-1 fw-bold">8%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}

            </div>
          </div>
        </div>

      </div>
    </div>
    <div className="col-xxl-2 col-md-2">
    <div className="card info-card  sales-card bg-gradient-info card-img-holder">
<div className="card-body">
<img src={Circles} className="card-img-absolute" alt="circle-image"/> 
          <h5 className="card-title">Active Survey <span>| This Year</span></h5>

          <div className="d-flex align-items-center">
            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
            <i><FontAwesomeIcon icon={faUser} /> </i>
            </div>
            <div className="ps-3">
              <h6></h6>
              {/* <span className="text-success small pt-1 fw-bold">8%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}

            </div>
          </div>
        </div>

      </div>
    </div>
    <div className="col-xxl-2 col-md-2">
    <div className="card info-card  sales-card bg-gradient-success card-img-holder">
<div className="card-body">
<img src={Circles} className="card-img-absolute" alt="circle-image"/> 
          <h5 className="card-title">Active Survey <span>| This Year</span></h5>

          <div className="d-flex align-items-center">
            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
            <i><FontAwesomeIcon icon={faUser} /> </i>
            </div>
            <div className="ps-3">
              <h6></h6>
              {/* <span className="text-success small pt-1 fw-bold">8%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}

            </div>
          </div>
        </div>

      </div>
    </div>
    <div className="col-xxl-2 col-md-2">
    <div className="card info-card  sales-card bg-gradient-success card-img-holder">
<div className="card-body">
<img src={Circles} className="card-img-absolute" alt="circle-image"/> 
          <h5 className="card-title">Active Survey <span>| This Year</span></h5>

          <div className="d-flex align-items-center">
            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
            <i><FontAwesomeIcon icon={faUser} /> </i>
            </div>
            <div className="ps-3">
              <h6></h6>
              {/* <span className="text-success small pt-1 fw-bold">8%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}

            </div>
          </div>
        </div>

      </div>
    </div>
    
        </div>
<div className='row'>
    <div className='col-md-6'>
    <div className='card'>
    <div className='card-body'>
        <div className='table-responsive'>
            <table className='table table-bordered'>
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>State</th>
                        <th>District</th>
                        <th>Taluka</th>
                        <th>Village</th>
                        <th>No. of Farmer</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>Uttar Pradesh</td>
                        <td>Agra</td>
                        <td>Etmadpur</td>
                        <td>Arela</td>
                    </tr>
                </tbody>
            </table>
        </div> 
    </div>
 </div>
    </div>
    <div className='col-md-6'>
    <div className='card'>
    <div className='card-body'>
     
    </div>
 </div>
    </div>
</div>
 </div>
 </main>
</>
        );
    }
    export default NaturalFarmingAnalytic